
export const adelaidenow = {
  id: 'adv',
  caasId: 'adelaidenow',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'AAWEB_WID100',
  label: 'The Advertiser'
};

export const cairnspost = {
  id: 'cp',
  caasId: 'cairnspost',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'CPWEB_WID100',
  label: 'Cairns Post'
};

export const couriermail = {
  id: 'cm',
  caasId: 'couriermail',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'CMWEB_WID100',
  label: 'The Courier-Mail'
};

export const heraldsun = {
  id: 'hs',
  caasId: 'heraldsun',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'HSWEB_WID100',
  label: 'Herald Sun'
};

export const foxsports = {
  id: 'fs',
  caasId: 'foxsports',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'FSWEB_WID100',
  label: 'Fox Sports'
};

export const geelongadvertiser = {
  id: 'ga',
  caasId: 'geelongadvertiser',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'GAWEB_WID100',
  label: 'Geelong Advertiser'
};

export const goldcoastbulletin = {
  id: 'gcb',
  caasId: 'goldcoastbulletin',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'GCWEB_WID100',
  label: 'Gold Coast Bulletin'
};

export const kidsnews = {
  id: 'kids',
  caasId: 'kidsnews',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'KNWEB_WID100',
  label: 'Kids News'
};

export const ntnews = {
  id: 'ntn',
  caasId: 'ntnews',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'NTWEB_WID100',
  label: 'NT News'
};

export const themercury = {
  id: 'merc',
  caasId: 'themercury',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'TMWEB_WID100',
  label: 'The Mercury'
};

export const townsvillebulletin = {
  id: 'tb',
  caasId: 'townsvillebulletin',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'TBWEB_WID100',
  label: 'Townsville Bulletin'
};

export const weeklytimesnow = {
  id: 'wtn',
  caasId: 'weeklytimesnow',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'WTWEB_WID100',
  label: 'The Weekly Times'
};

export const dailytelegraph = {
  id: 'dt',
  caasId: 'dailytelegraph',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'DTWEB_WID100',
  label: 'The Daily Telegraph'
};

export const theaustralian = {
  id: 'taus',
  caasId: 'theaustralian',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'TAWEB_WID100',
  label: 'The Australian'
};

export const newscomau = {
  id: 'newscomau',
  caasId: 'newscomau',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'news',
  sourceCode: 'NEWEB_WID100',
  label: 'News.com.au'
};


export const thechronicle = {
  id: 'twc',
  caasId: 'thechronicle',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  sourceCode: 'TCWEB_WID100',
  label: 'The Chronicle'
};

export const skynews = {
  id: 'sky',
  caasId: 'sn',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'sn',
  sourceCode: 'SKYWEB_WID100',
  label: 'Sky News'
};


export const escape = {
  id: 'escape',
  caasId: '',
  env: [ /* 'local', 'sit', 'uat', 'prod' */ ],
  basename: 'escape',
  sourceCode: '',
  label: 'Escape'
};

export const kidspot = {
  id: 'kidspot',
  caasId: 'kidspot',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'kidspot',
  sourceCode: 'KSWEB_WID100',
  label: 'Kidspot'
};

export const bodyandsoul = {
  id: 'body',
  caasId: 'body',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'bodyandsoul',
  sourceCode: 'BSWEB_WID100',
  label: 'Body + Soul'
};

export const taste = {
  id: 'taste',
  caasId: '',
  env: [ /* 'local', 'sit', 'uat', 'prod' */ ],
  basename: 'taste',
  sourceCode: '',
  label: 'Taste'
};


export const delicious = {
  id: 'delicious',
  caasId: '',
  env: [ /* 'local', 'sit', 'uat', 'prod' */ ],
  basename: 'delicious',
  sourceCode: '',
  label: 'Delicious'
};


export const bestrecipes = {
  id: 'bestrecipes',
  caasId: '',
  env: [ /* 'local', 'sit', 'uat', 'prod' */ ],
  basename: 'bestrecipes',
  sourceCode: '',
  label: 'Best Recipes'
};

export const gq = {
  id: 'gq',
  caasId: 'gq',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'gq',
  sourceCode: 'GQWEB_WID100',
  label: 'GQ'
};

export const vogue = {
  id: 'vogue',
  caasId: 'vogue',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'vogue',
  sourceCode: 'VGWEB_WID100',
  label: 'Vogue'
};

export const codesports = {
  id: 'code',
  caasId: 'code',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'codesports',
  sourceCode: 'CODEWEB_WID100',
  label: 'Codesports'
};

// App config for sites with diff ids
export const adelaidenowApp = {
  id: 'aa',
  caasId: 'adelaidenow',
  env: [ 'local', 'sit', 'uat' ],
  sourceCode: 'AAWEB_WID100',
  disableInPreview: true
};


export const newscomauApp = {
  id: 'nca',
  caasId: 'newscomau',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'news',
  sourceCode: 'NEWEB_WID100',
  disableInPreview: true
};


export const newsTest = {
  id: 'news',
  caasId: 'newscomau',
  env: [ 'local', 'sit', 'uat', 'prod' ],
  basename: 'news',
  sourceCode: 'NEWEB_WID100',
  disableInPreview: true
};


const mastheadConfig = new Map([
  [ dailytelegraph.id, dailytelegraph ],
  [ newscomau.id, newscomau ],
  [ theaustralian.id, theaustralian ],
  [ adelaidenow.id, adelaidenow ],
  [ cairnspost.id, cairnspost ],
  [ couriermail.id, couriermail ],
  [ foxsports.id, foxsports ],
  [ geelongadvertiser.id, geelongadvertiser ],
  [ goldcoastbulletin.id, goldcoastbulletin ],
  [ heraldsun.id, heraldsun ],
  [ kidsnews.id, kidsnews ],
  [ ntnews.id, ntnews ],
  [ themercury.id, themercury ],
  [ townsvillebulletin.id, townsvillebulletin ],
  [ weeklytimesnow.id, weeklytimesnow ],
  [ thechronicle.id, thechronicle ],
  [ skynews.id, skynews ],
  [ escape.id, escape ],
  [ kidspot.id, kidspot ],
  [ bodyandsoul.id, bodyandsoul ],
  [ taste.id, taste ],
  [ delicious.id, delicious ],
  [ bestrecipes.id, bestrecipes ],
  [ gq.id, gq ],
  [ vogue.id, vogue ],
  [ codesports.id, codesports ],

  // app
  [ adelaidenowApp.id, adelaidenowApp ],
  [ newscomauApp.id, newscomauApp ],

  // test / bob local
  [ newsTest.id, newsTest ],
]);

console.log('mastheadConfig', mastheadConfig);


export const mastheadValuesArray = [ ...mastheadConfig.values() ];

const getIdsForEnv = env => mastheadValuesArray
  .filter(masthead => masthead.env.includes(env))
  .map(masthead => masthead.id);

export const mastheads_local = getIdsForEnv('local');
export const mastheads_sit = getIdsForEnv('sit');
export const mastheads_dev = mastheads_sit;
export const mastheads_uat = getIdsForEnv('uat');
export const mastheads_prod = getIdsForEnv('prod');

export const getSiteLogo = (siteId) => {
  if (mastheadConfig.has(siteId)) {
    return mastheadConfig.get(siteId).logo;
  }
  console.warn(`No site found with id: ${ siteId }`);
};

export default mastheadConfig;
